import React from 'react';

export default function Tank27Icon({
  width = 64,
  height = 31,
  startColor = '#3A3A3A',
  midColor = '#BABABA',
  endColor = '#3A3A3A'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 54" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="56.3931" y1="54" x2="56.3931" y2="9.0005">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.01" style={{stopColor: "#3D3D3D"}} />
		<stop offset="0.12" style={{stopColor: "#696969"}} />
		<stop offset="0.22" style={{stopColor: "#8C8C8C"}} />
		<stop offset="0.33" style={{stopColor: "#A6A6A6"}} />
		<stop offset="0.42" style={{stopColor: "#B5B5B5"}} />
		<stop offset="0.49" style={{stopColor: "#BABABA"}} />
		<stop offset="0.57" style={{stopColor: "#B5B5B5"}} />
		<stop offset="0.66" style={{stopColor: "#A6A6A6"}} />
		<stop offset="0.77" style={{stopColor: "#8C8C8C"}} />
		<stop offset="0.88" style={{stopColor: "#696969"}} />
		<stop offset="0.99" style={{stopColor: "#3D3D3D"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M6.031,54L1.59,31.575L6.781,9l98.853,0.021l5.563,22.845L106.488,54H6.031z" />
	
		<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="-111.4336" y1="-18.5088" x2="-0.6558" y2="-18.5088" gradientTransform="matrix(0.0094 0.4063 -0.2397 -0.0054 104.0111 54.2138)">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.48" style={{stopColor: "#BABABA"}} />
		<stop offset="0.58" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.78" style={{stopColor: "#767676"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M112.482,31.529C112.07,13.642,105.718,9,105.718,9s-2.77,4.77-2.364,22.32   c0.384,16.62,2.979,22.68,2.979,22.68S112.885,48.932,112.482,31.529z" />
	
		<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="-111.2993" y1="-15.9268" x2="-0.5215" y2="-15.9268" gradientTransform="matrix(-0.0094 0.4063 0.2397 -0.0054 7.8717 54.1733)">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.48" style={{stopColor: "#BABABA"}} />
		<stop offset="0.58" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.78" style={{stopColor: "#767676"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M0.018,31.529C0.43,13.642,6.783,9,6.783,9s2.77,4.77,2.364,22.32C8.762,47.94,6.167,54,6.167,54   S-0.385,48.932,0.018,31.529z" />
</g>
<g id="Group_Port">
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="38.4751" y1="5.8018" x2="57.1504" y2="5.8018">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.48" style={{stopColor: "#BABABA"}} />
		<stop offset="0.58" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.78" style={{stopColor: "#767676"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M38.475,2.167H57.15v7.27H38.475V2.167z" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="35.5498" y1="1.4624" x2="60.0752" y2="1.4624">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.48" style={{stopColor: "#BABABA"}} />
		<stop offset="0.58" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.78" style={{stopColor: "#767676"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M35.55,0h24.525v2.925H35.55V0" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="54" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
